<template>
    <div class="modal-common" @click="clickOutside" v-if="isModalOpen">
        <div class="modal-common-content">
            <span class="close" @click="closeModal">&times;</span>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import EventBus from "@/utils/EventBus"
export default {
    data() {
        return {
            isModalOpen: false,
        }
    },
    created() {
        EventBus.$on("on-show-modal", () => this.openModal())
    },

    destroyed() {
        EventBus.$off("on-show-modal")
    },
    methods: {
        openModal() {
            this.isModalOpen = true
        },
        closeModal() {
            this.isModalOpen = false
        },
        clickOutside(event) {
            if (event.target.classList.contains("modal-common")) {
                this.closeModal()
            }
        },
    },
}
</script>

<style lang="scss">
@import "~ThemePath/scss/common/modal/index.scss";
</style>
